import { Component, inject, signal, viewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { SignatureCanvasComponent } from '../../../liveformseditor/items/SignatureItem/SignatureCanvas/signature-canvas.component';
import { LiveFormsTranslateLoaderService } from '../../../services/live-forms-translate-loader.service';

export interface SignatureCanvasDialogData {
  title: string;
}

@Component({
  selector: 'lfe-signature-canvas-dialog',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton, SignatureCanvasComponent],
  templateUrl: './signature-canvas-dialog.component.html',
  styleUrl: './signature-canvas-dialog.component.css'
})
export class SignatureCanvasDialogComponent {
  readonly signatureCanvas = viewChild<SignatureCanvasComponent>('signatureCanvas');

  private readonly dialogRef = inject(MatDialogRef<SignatureCanvasDialogComponent>);
  readonly data: SignatureCanvasDialogData = inject(MAT_DIALOG_DATA);
  readonly translateService = inject(LiveFormsTranslateLoaderService);

  hasDrawn = signal(false);

  onCanvasDrawn(drawn: boolean): void {
    this.hasDrawn.set(drawn);
  }

  save(): void {
    const base64 = this.signatureCanvas()?.getBase64();
    this.dialogRef.close(base64);
  }
}
